import React, { Component } from 'react';
import { history } from '../../helpers';

export class Error401 extends Component {
    handleGoBack = (e) => {
        e.preventDefault();
        //뒤로가기
        history.goBack();
    }
    render() {
        return (
            <React.Fragment>
                <div>
                    <div className="div-table-display error-title-wrapper">
                        <div>
                            <img src="/assets/images/img-404.svg" className="img-404" alt="error 404"/>
                        </div>
                        <div className="error-title">
                            401 에러
                        </div>
                    </div>
                </div>
                <div className="error-main-info">
                    죄송합니다. 승인 처리를 실패하였습니다.
                </div>
                <div className="h60"></div>
                <div className="text-align-center">
                    <button className="button primary-button" variant="contained" color="primary" onClick={this.handleGoBack}>
                        뒤로가기
                    </button>
                    <button className="button outline-button" variant="contained" color="primary" onClick={this.handleGoBack}>
                        다시로그인하기
                    </button>
                </div>
            </React.Fragment>
        );
    }
}

export class Error403 extends Component {
    handleGoBack = (e) => {
        e.preventDefault();
        //뒤로가기
        history.goBack();
    }
    render() {
        return (
            <React.Fragment>
                <div>
                    <div className="div-table-display error-title-wrapper">
                        <div>
                            <img src="/assets/images/img-404.svg" className="img-404" alt="error 404"/>
                        </div>
                        <div className="error-title">
                            403 에러
                        </div>
                    </div>
                </div>
                <div className="error-main-info">
                    죄송합니다. 해당페이지에 접근 권한이 없습니다.
                </div>
                <div className="h60"></div>
                <div className="text-align-center">
                    <button className="button primary-button" variant="contained" color="primary" onClick={this.handleGoBack}>
                        뒤로가기
                    </button>
                </div>
            </React.Fragment>
        );
    }
}

export class Error404 extends Component {
    handleGoBack = (e) => {
        e.preventDefault();
        //뒤로가기
        history.goBack();
    }
    render() {
        return (
            <React.Fragment>
                <div>
                    <div className="div-table-display error-title-wrapper">
                        <div>
                            <img src="/assets/images/img-404.svg" className="img-404" alt="error 404"/>
                        </div>
                        <div className="error-title">
                            404 에러
                        </div>
                    </div>
                </div>
                <div className="error-main-info">
                    죄송합니다. 요청하신 페이지를 찾을 수 없습니다.
                </div>
                <div className="error-commnet">
                    접속하시려는 페이지의 주소(URL)가 잘못 입력되거나,
                </div>
                <div className="error-commnet">
                    페이지의 주소가 변경 또는 삭제 되어 해당 페이지에 접속 할 수 없습니다.
                </div>
                <div className="h60"></div>
                <div className="text-align-center">
                    <button className="button primary-button" variant="contained" color="primary" onClick={this.handleGoBack}>
                        뒤로가기
                    </button>
                </div>
            </React.Fragment>
        );
    }
}
